import React, { useContext, useEffect, useRef, useState } from "react";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import { Alert, Button, Col, Form, Row } from "react-bootstrap";
import { MdSave } from "react-icons/md";
import { MdAddAPhoto, MdCameraAlt, MdStopCircle } from "react-icons/md";
import firebase from "firebase/compat/app";
import "firebase/compat/storage";
import { AuthContext } from "../../../contexts/AuthContext";
import { tempUrl } from "../../../contexts/ContextProvider";
import { Loader, ScrollToTop } from "../../../components";

const TambahEntryPermohonan = () => {
  const { user, dispatch } = useContext(AuthContext);
  const navigate = useNavigate();
  const videoRef = useRef(null);
  const canvasRef = useRef(null);
  const streamRef = useRef(null);

  const [namaPemohon, setNamaPemohon] = useState("");
  const [fotoKtp, setFotoKtp] = useState([]);
  const [fotoKk, setFotoKk] = useState([]);
  const [fotoPenjamin, setFotoPenjamin] = useState([]);
  const [fotoKendaraan, setFotoKendaraan] = useState([]);
  const [fotoStnkBpkb, setFotoStnkBpkb] = useState([]);
  const [fotoLingkungan, setFotoLingkungan] = useState([]);
  const [fotoLainPendukung, setFotoLainPendukung] = useState([]);
  const [previewKtp, setPreviewKtp] = useState([]);
  const [previewKk, setPreviewKk] = useState([]);
  const [previewPenjamin, setPreviewPenjamin] = useState([]);
  const [previewKendaraan, setPreviewKendaraan] = useState([]);
  const [previewStnkBpkb, setPreviewStnkBpkb] = useState([]);
  const [previewLingkungan, setPreviewLingkungan] = useState([]);
  const [previewLainPendukung, setPreviewLainPendukung] = useState([]);
  const [activeFotoKey, setActiveFotoKey] = useState("");
  const [cameraActive, setCameraActive] = useState(false);
  const [cameraError, setCameraError] = useState("");
  const [currentLocation, setCurrentLocation] = useState(null);
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    return () => {
      stopCamera(false);
    };
  }, []);

  const fotoSections = [
    { key: "fotoKtp", title: "Foto KTP", files: fotoKtp, previews: previewKtp, setFiles: setFotoKtp, setPreviews: setPreviewKtp },
    { key: "fotoKk", title: "KK", files: fotoKk, previews: previewKk, setFiles: setFotoKk, setPreviews: setPreviewKk },
    { key: "fotoPenjamin", title: "Penjamin", files: fotoPenjamin, previews: previewPenjamin, setFiles: setFotoPenjamin, setPreviews: setPreviewPenjamin },
    { key: "fotoKendaraan", title: "Kendaraan Depan/Belakang", files: fotoKendaraan, previews: previewKendaraan, setFiles: setFotoKendaraan, setPreviews: setPreviewKendaraan },
    { key: "fotoStnkBpkb", title: "STNK & BPKB", files: fotoStnkBpkb, previews: previewStnkBpkb, setFiles: setFotoStnkBpkb, setPreviews: setPreviewStnkBpkb },
    { key: "fotoLingkungan", title: "Lingkungan", files: fotoLingkungan, previews: previewLingkungan, setFiles: setFotoLingkungan, setPreviews: setPreviewLingkungan },
    { key: "fotoLainPendukung", title: "Lain2 Pendukung", files: fotoLainPendukung, previews: previewLainPendukung, setFiles: setFotoLainPendukung, setPreviews: setPreviewLainPendukung },
  ];

  const handleAuthError = (err) => {
    if (err.response?.status === 401) {
      dispatch({ type: "LOGOUT" });
      navigate("/");
    }
  };

  const getCurrentLocation = () => {
    return new Promise((resolve, reject) => {
      if (!navigator.geolocation) {
        reject(new Error("Browser tidak mendukung akses lokasi."));
        return;
      }

      navigator.geolocation.getCurrentPosition(
        (position) => {
          resolve({
            latitude: position.coords.latitude,
            longitude: position.coords.longitude,
            accuracy: position.coords.accuracy,
            capturedAt: new Date().toISOString(),
          });
        },
        () => reject(new Error("Lokasi/GPS wajib aktif sebelum membuka kamera.")),
        {
          enableHighAccuracy: true,
          timeout: 15000,
          maximumAge: 0,
        },
      );
    });
  };

  const waitForVideoElement = () => {
    return new Promise((resolve) => {
      const findVideo = () => {
        if (videoRef.current) {
          resolve(videoRef.current);
          return;
        }

        setTimeout(findVideo, 30);
      };

      findVideo();
    });
  };

  const playCameraStream = async (stream) => {
    const video = await waitForVideoElement();
    video.srcObject = stream;

    try {
      await video.play();
    } catch (err) {
      const isInterruptedPlay =
        err.name === "AbortError" ||
        err.message?.includes("interrupted by a new load request");

      if (!isInterruptedPlay) {
        throw err;
      }

      setTimeout(() => {
        if (video.srcObject === stream) {
          video.play().catch(() => {});
        }
      }, 120);
    }
  };

  const startCamera = async (fotoKey) => {
    try {
      stopCamera(false);
      setCameraError("");
      setActiveFotoKey(fotoKey);

      const location = await getCurrentLocation();
      setCurrentLocation(location);

      if (!navigator.mediaDevices || !navigator.mediaDevices.getUserMedia) {
        setCameraError("Browser tidak mendukung akses kamera.");
        return;
      }

      const stream = await navigator.mediaDevices.getUserMedia({
        video: {
          facingMode: { ideal: "environment" },
        },
        audio: false,
      });

      streamRef.current = stream;
      await playCameraStream(stream);

      setCameraActive(true);
    } catch (err) {
      setCameraError(err.message || "Kamera tidak bisa dibuka. Pastikan izin kamera dan lokasi diberikan.");
      console.log(err);
    }
  };

  const stopCamera = (updateState = true) => {
    if (streamRef.current) {
      streamRef.current.getTracks().forEach((track) => track.stop());
      streamRef.current = null;
    }

    if (videoRef.current) {
      videoRef.current.srcObject = null;
    }

    if (updateState) {
      setCameraActive(false);
      setActiveFotoKey("");
      setCurrentLocation(null);
    }
  };

  const capturePhoto = async (section) => {
    if (!videoRef.current || !canvasRef.current) {
      return;
    }

    let latestLocation = currentLocation;

    try {
      latestLocation = await getCurrentLocation();
      setCurrentLocation(latestLocation);
    } catch (err) {
      setCameraError("Lokasi/GPS wajib aktif sebelum mengambil foto.");
      return;
    }

    const video = videoRef.current;
    const canvas = canvasRef.current;
    const width = video.videoWidth;
    const height = video.videoHeight;

    if (!width || !height) {
      setCameraError("Kamera belum siap. Coba ambil foto sekali lagi.");
      return;
    }

    canvas.width = width;
    canvas.height = height;
    canvas.getContext("2d").drawImage(video, 0, 0, width, height);

    canvas.toBlob(
      (blob) => {
        if (!blob) {
          setCameraError("Foto gagal diambil. Coba ulangi.");
          return;
        }

        const fileName = `permohonan-${section.key}-${Date.now()}.jpg`;
        const capturedFile = new File([blob], fileName, {
          type: "image/jpeg",
          lastModified: Date.now(),
        });

        section.setFiles((prevFiles) => [
          ...prevFiles,
          {
            file: capturedFile,
            latitude: latestLocation.latitude,
            longitude: latestLocation.longitude,
            accuracy: latestLocation.accuracy,
            capturedAt: latestLocation.capturedAt,
          },
        ]);
        section.setPreviews((prevPreviews) => [...prevPreviews, URL.createObjectURL(capturedFile)]);
        setCameraError("");
      },
      "image/jpeg",
      0.9,
    );
  };

  const uploadFotoGroup = async (files) => {
    const uploadedImageUrls = await Promise.all(
      files.map(async (selectedPhoto) => {
        const selectedFile = selectedPhoto.file || selectedPhoto;
        const storageRef = firebase.storage().ref();
        const fileRef = storageRef.child(
          `${Date.now()}-${Math.floor(Math.random() * 1000 + 1)}-${selectedFile.name}`,
        );
        const snapshot = await fileRef.put(selectedFile);
        const url = await snapshot.ref.getDownloadURL();

        return {
          url,
          latitude: selectedPhoto.latitude,
          longitude: selectedPhoto.longitude,
          accuracy: selectedPhoto.accuracy,
          capturedAt: selectedPhoto.capturedAt,
        };
      }),
    );

    return uploadedImageUrls;
  };

  const saveEntryPermohonan = async (event) => {
    event.preventDefault();

    if (!namaPemohon) {
      setError("Nama pemohon wajib diisi.");
      return;
    }

    setLoading(true);
    try {
      const savedEntryPermohonan = await axios.post(`${tempUrl}/savePermohonan`, {
        namaPemohon,
        id: user._id,
        token: user.token,
      });

      const entryPermohonanId = savedEntryPermohonan.data._id;
      const fotoKtpUploaded = await uploadFotoGroup(fotoKtp);
      const fotoKkUploaded = await uploadFotoGroup(fotoKk);
      const fotoPenjaminUploaded = await uploadFotoGroup(fotoPenjamin);
      const fotoKendaraanUploaded = await uploadFotoGroup(fotoKendaraan);
      const fotoStnkBpkbUploaded = await uploadFotoGroup(fotoStnkBpkb);
      const fotoLingkunganUploaded = await uploadFotoGroup(fotoLingkungan);
      const fotoLainPendukungUploaded = await uploadFotoGroup(fotoLainPendukung);

      await axios.post(`${tempUrl}/uploadFotoPermohonan/${entryPermohonanId}`, {
        fotoKtp: fotoKtpUploaded,
        fotoKk: fotoKkUploaded,
        fotoPenjamin: fotoPenjaminUploaded,
        fotoKendaraan: fotoKendaraanUploaded,
        fotoStnkBpkb: fotoStnkBpkbUploaded,
        fotoLingkungan: fotoLingkunganUploaded,
        fotoLainPendukung: fotoLainPendukungUploaded,
        id: user._id,
        token: user.token,
      });

      navigate("/permohonan");
    } catch (err) {
      handleAuthError(err);
      setError(err.response?.data?.message || "Gagal menyimpan permohonan.");
      setLoading(false);
    }
  };

  const renderFotoInput = (section) => {
    return (
      <section className="section-panel mt-3" key={section.key}>
        <h2 className="h6 fw-bold mb-3">{section.title}</h2>
        {cameraError && activeFotoKey === section.key && <Alert variant="warning">{cameraError}</Alert>}
        <div className="camera-box">
          {activeFotoKey === section.key && (
            <>
              <video
                ref={videoRef}
                playsInline
                muted
                className="camera-preview"
                style={{ display: cameraActive ? "block" : "none" }}
              />
              <canvas ref={canvasRef} style={{ display: "none" }} />
            </>
          )}
        </div>
        <div className="form-actions mb-3">
          <Button className="btn-icon" type="button" onClick={() => startCamera(section.key)} disabled={cameraActive && activeFotoKey === section.key}>
            <MdCameraAlt /> Buka Kamera
          </Button>
          <Button className="btn-icon" type="button" variant="success" onClick={() => capturePhoto(section)} disabled={!cameraActive || activeFotoKey !== section.key}>
            <MdAddAPhoto /> Ambil Foto
          </Button>
          <Button className="btn-icon" type="button" variant="outline-secondary" onClick={stopCamera} disabled={!cameraActive || activeFotoKey !== section.key}>
            <MdStopCircle /> Tutup Kamera
          </Button>
        </div>
        <div className="photo-grid">
          {section.previews.map((img, i) => (
            <button className="photo-card" key={`${section.key}-${i}`} type="button">
              <img src={img} alt={`${section.title} ${i + 1}`} />
              <span>No. {i + 1}</span>
            </button>
          ))}
        </div>
      </section>
    );
  };

  if (loading) {
    return <Loader />;
  }

  return (
    <div>
      <ScrollToTop />
      <div className="page-header">
        <div>
          <div className="page-kicker">Survey</div>
          <h1 className="page-title">Tambah Entry Permohonan</h1>
        </div>
      </div>
      <section className="section-panel">
        {error && <Alert variant="warning">{error}</Alert>}
        <Form onSubmit={saveEntryPermohonan}>
          <Row>
            <Col lg={6} md={8}>
              <Form.Group className="mb-3">
                <Form.Label>Nama Pemohon</Form.Label>
                <Form.Control
                  value={namaPemohon}
                  onChange={(e) => setNamaPemohon(e.target.value)}
                />
              </Form.Group>
            </Col>
          </Row>
          {fotoSections.map((section) => renderFotoInput(section))}
          <div className="form-actions mt-3">
            <Button className="btn-back" type="button" variant="outline-secondary" onClick={() => navigate("/permohonan")}>
              {"< Kembali"}
            </Button>
            <Button className="btn-icon" type="submit">
              <MdSave /> Simpan
            </Button>
          </div>
        </Form>
      </section>
    </div>
  );
};

export default TambahEntryPermohonan;
